import React, { useState, useContext } from 'react'
import './Todo.scss'
import { Button } from '../generic/UI/Button/Button'
import { database } from '../../firebaseConfig'
import { useEffect } from 'react'
import firebase from './../../firebaseConfig';
import { TodoItem } from './TodoItem/TodoItem';
import { Context } from '../../context'

function useTodos(uid) {
    const [todos, setTodos] = useState([])

    useEffect(() => {
        const unsubscribe = firebase
        database
            .collection(uid)
            .onSnapshot((snapshot) => {
                const newTodos = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setTodos(newTodos)
            })
        return () => unsubscribe
    }, [uid])

    return todos
}

const Todo = props => {

    const { user } = useContext(Context)


    const todoList = useTodos(user.uid)

    const [value, setValue] = useState()


    const changeHandler = event => setValue(event.target.value)

    const submitHandler = () => {
        let date = new Date()
        database
            .collection(user.uid)
            .add({
                text: value,
                isCompleted: false,
                date: `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`
            })
        setValue('')
    }

    const deleteHandler = id => database.collection(user.uid).doc(id).delete()


    return (
        <div className="todo">
            <div className="todo__input">
                <textarea value={value} onChange={changeHandler} placeholder='Мне нужно...' name=""></textarea>
                <Button onClick={submitHandler} class='add' name='+' />
            </div>
            <div className="todo__list">
                {todoList.length ? todoList.map(todo => <TodoItem text={todo.text} id={todo.id} uid={user.uid} deleteHandler={() => deleteHandler(todo.id)} date={todo.date} isCompleted={todo.isCompleted} key={Math.random()} />) : <p style={{ textAlign: 'center', padding: '100px' }}>Пусто..</p>}
            </div>
        </div>
    )
}


export default Todo